import { Navigate } from "react-router-dom";
import { getConfigName } from "@helpers/funciones";
import { ofertaPorEmpresa } from "@helpers/ofertaConfig";
import { PATHS_TOFU_V2 } from "@helpers/constantes";

/**
 * Monta la pre-oferta del tenant (ver `ofertaPorEmpresa`). Una empresa sin pre-oferta propia todavía no tiene
 * esta pantalla en su flujo, así que se queda en la sala de espera.
 */
export const OfertaPorEmpresa = () => {
  const Component = ofertaPorEmpresa[getConfigName(window.location.href)];
  return Component ? <Component /> : <Navigate to={PATHS_TOFU_V2.waitingRoom.path} replace />;
};
